import { BOOKING_LOCATION } from '../conts';

export const useBookingUrl = () => {
  const location = localStorage.getItem(BOOKING_LOCATION) ?? null;
  return location ? `book-${location}` : 'book';
};
